import type { Catalog } from '@smarton-pbx/shared';

/** Call flows: the flows, the editor, prompts, hold music, opening hours and caller lists. */
export const flows: Catalog = {
  // The section's tabs (SectionTabs.tsx).
  Flows: 'Scenarijai',
  Prompts: 'Garso pranešimai',
  'Hold music': 'Laukimo muzika',
  'Opening hours': 'Darbo laikas',
  'Caller lists': 'Skambintojų sąrašai',

  // The flows (FlowsPage.tsx).
  'Delete the flow {name}?': 'Ištrinti scenarijų „{name}“?',
  'What happens to a call to your numbers: menus, opening hours, queues, voicemail. Draw it, test it, publish it.':
    'Kas vyksta, kai skambinama jūsų numeriais: meniu, darbo laikas, eilės, balso paštas. Nubraižykite, išbandykite ir paskelbkite.',
  'New flow': 'Naujas scenarijus',
  'No call flows yet': 'Skambučių scenarijų dar nėra',
  'Start from a template such as “menu, opening hours, queue, voicemail”, then point a number at it.':
    'Pradėkite nuo šablono, pavyzdžiui, „meniu, darbo laikas, eilė, balso paštas“, tada nukreipkite į jį numerį.',
  Flow: 'Scenarijus',
  'version|Live': 'Veikia',
  '{region} · changed {date}': '{region} · pakeistas {date}',
  'Version {n}': '{n} versija',
  'Version {n} · draft changed': '{n} versija · juodraštis pakeistas',
  'Not published': 'Nepaskelbtas',
  'Actions for {name}': 'Veiksmai: {name}',
  'action|Open': 'Atidaryti',
  // A flow's, prompt's, list's... name (common's Name is a person's).
  'thing|Name': 'Pavadinimas',
  'New call flow': 'Naujas skambučių scenarijus',
  'Main line': 'Pagrindinė linija',
  'Its prompts, queues and numbers are the region’s': 'Naudos šio regiono garso pranešimus, eiles ir numerius',
  'Start from': 'Pradėti nuo',
  'An empty flow': 'Tuščias scenarijus',
  'Just the Start.': 'Tik elementas „Pradžia“.',
  Create: 'Sukurti',
  // Templates (shared flowTemplates, sent by the API).
  'Menu, opening hours, queue, voicemail': 'Meniu, darbo laikas, eilė, balso paštas',
  'Open: a menu sends callers to Sales (1) or Support (2). Closed, or nobody answers: a message.':
    'Darbo metu meniu nukreipia skambinančiuosius į Sales (1) arba Support (2). Ne darbo metu arba kai niekas neatsiliepia – balso žinutė.',
  'Tech line with sales hours': 'Techninė linija su pardavimų darbo laiku',
  'A menu: 1, no key or a wrong key go to Tech; 2 goes to Sales while Sales is open, else to Tech. Unanswered callers get a callback.':
    'Meniu: 1, nepaspaustas ar neteisingas klavišas veda į Tech; 2 – į Sales, kol Sales dirba, kitu metu – į Tech. Skambinantiesiems, kuriems neatsiliepta, perskambinama.',
  'Opening hours, queue, voicemail': 'Darbo laikas, eilė, balso paštas',
  'One queue while open; a closed message and voicemail otherwise, or when nobody answers.':
    'Darbo metu – viena eilė; kitu metu arba kai niekas neatsiliepia – pranešimas ne darbo laiku ir balso paštas.',

  // The editor (FlowEditor.tsx).
  '“{name}” has no recording yet.': '„{name}“ dar neturi įrašo.',
  'Fix the marked elements first ({n}).': 'Pirmiausia ištaisykite pažymėtus elementus ({n}).',
  'Version {n} is live: new calls follow it now.': '{n} versija veikia: nauji skambučiai jau vyksta pagal ją.',
  'Publish version {n} again? It becomes the draft too.': 'Vėl paskelbti {n} versiją? Ji taip pat taps juodraščiu.',
  'Publish version {n} again? It becomes the draft too, and your unsaved changes are lost.':
    'Vėl paskelbti {n} versiją? Ji taip pat taps juodraščiu, o neišsaugoti pakeitimai bus prarasti.',
  'Version {n} is live again.': '{n} versija vėl veikia.',
  'Version {n} live': 'Veikia {n} versija',
  'Version {n} live · changes not published': 'Veikia {n} versija · pakeitimai nepaskelbti',
  'All flows': 'Visi scenarijai',
  'Flow name': 'Scenarijaus pavadinimas',
  '{n} to fix': 'Liko ištaisyti: {n}',
  Ready: 'Paruošta',
  Test: 'Išbandyti',
  'Save draft': 'Išsaugoti juodraštį',
  Publish: 'Paskelbti',
  More: 'Daugiau',
  'Hide calls': 'Slėpti skambučius',
  'Calls in the last 7 days': 'Skambučiai per pastarąsias 7 dienas',
  Versions: 'Versijos',
  'None published yet': 'Dar nė viena nepaskelbta',
  'Version {n} (live)': '{n} versija (veikia)',
  Elements: 'Elementai',
  'Drag onto the canvas, or click. Wire each way out (the dots below an element) to the next.':
    'Nuvilkite į darbo lauką arba spustelėkite. Kiekvieną išėjimą (taškelius elemento apačioje) sujunkite su kitu elementu.',
  'Select an element to set it up.': 'Pasirinkite elementą, kad jį nustatytumėte.',

  // Elements (shared flowNodeNames, as tc('element', name); Queue, Opening hours, Voicemail and
  // Language use the plain text's). Short: they fit the palette.
  'element|Start': 'Pradžia',
  'element|Menu': 'Meniu',
  'element|Play audio': 'Groti įrašą',
  'element|Callback': 'Perskambinti',
  'element|Transfer': 'Peradresuoti',
  'element|Caller list': 'Sąrašas',
  'element|Counter': 'Skaitiklis',
  'element|Go to flow': 'Į kitą scenarijų',
  'element|Hang up': 'Baigti skambutį',
  Queue: 'Eilė',
  // What each does (elements.tsx).
  'Where calls to the flow’s numbers begin': 'Čia prasideda skambučiai scenarijaus numeriais',
  'Plays a prompt and waits for a key': 'Groja garso pranešimą ir laukia klavišo',
  'Plays a prompt': 'Groja garso pranešimą',
  'Open, closed or a named period, by the schedule': 'Pagal grafiką: dirbama, nedirbama ar pavadintas laikotarpis',
  'Callers wait while the queue’s people are rung': 'Skambinantieji laukia, kol skambinama eilės darbuotojams',
  'Puts the caller on a missed-call list to be called back': 'Įtraukia skambinantįjį į praleistų skambučių sąrašą, kad jam būtų perskambinta',
  'Takes a message (and can email it)': 'Priima balso žinutę (ir gali ją išsiųsti el. paštu)',
  'Rings a person, or an outside number': 'Skambina darbuotojui arba į išorinį numerį',
  'Branches when the caller is on a list': 'Nukreipia kitu keliu, jei skambinantysis yra sąraše',
  'Counts the calls that pass, for reports': 'Skaičiuoja pro jį einančius skambučius ataskaitoms',
  'Prompts play in this language from here on': 'Nuo čia garso pranešimai grojami šia kalba',
  'Carries on in another flow': 'Skambutis tęsiamas kitame scenarijuje',
  'Ends the call': 'Baigia skambutį',
  // An element's ways out (shared flowExits; Next and No answer are in common, Answered elsewhere): the full
  // wording, as the flow checks name them (messages-lt), and in exit| the short one that fits under an element.
  'Wrong key': 'Neteisingas klavišas',
  'No key': 'Klavišas nepaspaustas',
  Open: 'Dirbama',
  Closed: 'Nedirbama',
  'Waited too long': 'Laukė per ilgai',
  'Nobody there': 'Nebuvo kam atsiliepti',
  'Asked for a callback': 'Paprašė perskambinti',
  'Not answered': 'Neatsiliepta',
  'On the list': 'Sąraše',
  'Not on it': 'Ne sąraše',
  'Too long': 'Per ilgai',
  'Nobody in': 'Nėra kam',
  'exit|Callback': 'Perskambinti',
  'exit|Wrong key': 'Neteisingas',
  'exit|No key': 'Be klavišo',
  // An element on the canvas.
  Missing: 'Nebėra',
  'No number yet': 'Numerio dar nėra',
  '{prompt} · waits {n} s': '{prompt} · laukia {n} s',
  'No prompt': 'Be garso pranešimo',
  'No schedule': 'Be grafiko',
  'No queue': 'Be eilės',
  'For {who}': 'Kam: {who}',
  'nobody yet': 'dar niekam',
  'Nobody yet': 'Dar niekam',
  'No list': 'Be sąrašo',
  'Counts calls': 'Skaičiuoja skambučius',
  'Name it to find it in reports': 'Pavadinkite, kad rastumėte ataskaitose',
  'No language': 'Be kalbos',
  'No flow': 'Be scenarijaus',
  'Step in the simulated call': 'Bandomojo skambučio žingsnis',
  'Calls in the period': 'Skambučiai per laikotarpį',

  // An element's settings (Inspector.tsx).
  'Counter name': 'Skaitiklio pavadinimas',
  'Name on the canvas': 'Pavadinimas darbo lauke',
  'Calls to these numbers follow this flow once it is published. A number moves here from wherever it led before.':
    'Paskelbus scenarijų, skambučiai šiais numeriais vyks pagal jį. Numeris perkeliamas čia iš ten, kur buvo nukreiptas anksčiau.',
  'The region has no numbers. Add one on the Numbers page.': 'Regionas neturi numerių. Pridėkite numerį puslapyje „Numeriai“.',
  '{number} now leads to {target}. Start this flow instead?': 'Numeris {number} dabar nukreiptas į: {target}. Vietoj to nukreipti į šį scenarijų?',
  'now {target}': 'dabar: {target}',
  Prompt: 'Garso pranešimas',
  'Keys that lead somewhere': 'Klavišai, kurie kur nors veda',
  'Each gets its own way out. Other keys go to “Wrong key”.': 'Kiekvienas gauna savo išėjimą. Kiti klavišai veda į „Neteisingas klavišas“.',
  'Wait for a key (seconds)': 'Kiek laukti klavišo (s)',
  'After the prompt': 'Po garso pranešimo',
  'All prompts': 'Visi garso pranešimai',
  'Read in the region’s time zone. Named periods (lunch) get their own way out.': 'Pagal regiono laiko juostą. Pavadinti laikotarpiai (pietūs) turi savo išėjimą.',
  'Choose a schedule': 'Pasirinkite grafiką',
  'Its own rules apply: who is rung, the longest wait, pressing 1 for a callback.':
    'Taikomi jos nustatymai: kam skambinama, ilgiausias laukimas, perskambinimas paspaudus 1.',
  'Choose a queue': 'Pasirinkite eilę',
  'Missed-call list of': 'Kurios eilės sąrašas',
  'Callers who waited in a queue stay on that queue’s list; others go on this one.': 'Skambinantieji, kurie laukė eilėje, lieka tos eilės sąraše; kiti patenka į šį.',
  'Also email each request to': 'Kiekvieną prašymą siųsti ir el. paštu',
  'Optional, e.g. a shared address': 'Neprivaloma, pvz., bendras adresas',
  'Messages are for': 'Kam skirtos žinutės',
  'A queue’s people': 'Eilės darbuotojams',
  'One person': 'Darbuotojui',
  'Choose a person': 'Pasirinkite darbuotoją',
  Greeting: 'Pasisveikinimas',
  'Also email each message to': 'Kiekvieną žinutę siųsti ir el. paštu',
  'Optional; the recording is attached': 'Neprivaloma; įrašas pridedamas',
  'Send the call to': 'Kam peradresuoti',
  'A person': 'Darbuotojui',
  'An outside number': 'Į išorinį numerį',
  'Their browsers and phone app ring, unless they are on a break': 'Skamba darbuotojo naršyklės ir telefono programėlė, nebent jis pertraukoje',
  'With the country code. It sees the number that was called.': 'Su šalies kodu. Ten matomas numeris, kuriuo buvo skambinta.',
  'Ring for (seconds)': 'Kiek skambinti (s)',
  'Caller list': 'Skambintojų sąrašas',
  'Choose a list': 'Pasirinkite sąrašą',
  'Prompts with a recording in it play in it; others in the region’s main language':
    'Garso pranešimai, įrašyti šia kalba, grojami ja; kiti – pagrindine regiono kalba',
  'Choose a language': 'Pasirinkite kalbą',
  'Its published version; the call starts at its Start': 'Paskelbta jo versija; skambutis prasideda nuo jo pradžios',
  'Choose a flow': 'Pasirinkite scenarijų',

  // A prompt in the editor (PromptPicker.tsx) and on the Prompts page.
  'Making the prompt…': 'Kuriamas garso pranešimas…',
  'That file is over 10 MB.': 'Šis failas didesnis nei 10 MB.',
  'Uploading…': 'Įkeliama…',
  'Converting for the phone…': 'Paruošiama telefonui…',
  'The standard one': 'Standartinis',
  'Choose a prompt': 'Pasirinkite garso pranešimą',
  'New prompt…': 'Naujas garso pranešimas…',
  'e.g. Welcome': 'pvz., Pasisveikinimas',
  'New prompt’s name': 'Naujo garso pranešimo pavadinimas',
  Make: 'Sukurti',
  'Recorded: {languages}': 'Įrašyta: {languages}',
  'No recording yet. Upload a file (a recording or music) or record one.': 'Įrašo dar nėra. Įkelkite failą (įrašą ar muziką) arba įrašykite.',
  'Stop · {n} s': 'Sustabdyti · {n} s',
  Record: 'Įrašyti',
  'The microphone isn’t available. Allow it in the browser, or upload a file.': 'Mikrofonas nepasiekiamas. Leiskite jį naudoti naršyklėje arba įkelkite failą.',
  // Languages prompts are recorded in (languages.ts).
  Lithuanian: 'Lietuvių',
  English: 'Anglų',
  Russian: 'Rusų',
  Polish: 'Lenkų',
  Latvian: 'Latvių',
  Estonian: 'Estų',
  German: 'Vokiečių',
  Finnish: 'Suomių',
  Ukrainian: 'Ukrainiečių',

  // Testing a flow (Simulator.tsx; Answered and When are elsewhere).
  'Test this flow': 'Scenarijaus išbandymas',
  'The path a call would take. No call is made; the draft is tested as it is.': 'Kokiu keliu eitų skambutis. Niekam neskambinama, išbandomas juodraštis toks, koks yra.',
  'Your computer’s time; opening hours are read in the region’s time zone': 'Jūsų kompiuterio laikas; darbo laikas tikrinamas pagal regiono laiko juostą',
  'Caller’s number': 'Skambinančiojo numeris',
  'Keys pressed': 'Paspausti klavišai',
  'One per menu reached, in order. _ for no key, e.g. 2_1': 'Po vieną kiekvienam meniu, iš eilės. _ – jokio klavišo, pvz., 2_1',
  'e.g. 2': 'pvz., 2',
  'Queue: {name}': 'Eilė: {name}',
  'Transfer: {name}': 'Peradresavimas: {name}',
  'Run the call': 'Paleisti skambutį',

  // The way a call went (CallPath.tsx, on a call's page).
  'Through the call flow': 'Kelias per skambučių scenarijų',
  'pressed {key}': 'paspaustas {key}',
  'wrong key': 'neteisingas klavišas',
  'wrong key ({key})': 'neteisingas klavišas ({key})',
  'no key': 'klavišas nepaspaustas',
  'waited too long': 'laukė per ilgai',
  'nobody there': 'nebuvo kam atsiliepti',
  'asked for a callback': 'paprašė perskambinti',
  answered: 'atsiliepta',
  'not answered': 'neatsiliepta',
  open: 'dirbama',
  closed: 'nedirbama',
  'on the list': 'sąraše',
  'not on the list': 'ne sąraše',

  // Prompts (parts.tsx).
  'Delete the prompt {name} and its recordings?': 'Ištrinti garso pranešimą „{name}“ ir jo įrašus?',
  'What callers hear in your call flows: greetings, menus, closed messages. Upload a file or record one here.':
    'Ką skambinantieji girdi jūsų skambučių scenarijuose: pasisveikinimai, meniu, pranešimai ne darbo laiku. Įkelkite failą arba įrašykite čia.',
  'New prompt': 'Naujas garso pranešimas',
  'No prompts yet': 'Garso pranešimų dar nėra',
  'Make one, then upload or record what callers should hear.': 'Sukurkite garso pranešimą, tada įkelkite arba įrašykite, ką turi išgirsti skambinantieji.',
  Recordings: 'Įrašai',
  'Used by': 'Kas naudoja',
  failed: 'nepavyko',
  converting: 'konvertuojama',
  'Add a recording': 'Pridėti įrašą',
  'Rename the prompt': 'Pervadinti garso pranešimą',
  '{name}: recordings': '{name}: įrašai',
  'The newest ready version of each language plays. Older ones stay until you delete them.':
    'Grojama naujausia paruošta kiekvienos kalbos versija. Senesnės lieka, kol jų neištrinsite.',
  Welcome: 'Pasisveikinimas',
  'Delete version {n}?': 'Ištrinti {n} versiją?',
  'Delete version {n}': 'Ištrinti {n} versiją',
  'No recording in this language yet.': 'Šia kalba įrašo dar nėra.',
  'No recording in this language is ready yet.': 'Šia kalba paruošto įrašo dar nėra.',
  Plays: 'Grojama',
  Converting: 'Konvertuojama',
  'Couldn’t convert': 'Nepavyko konvertuoti',
  Original: 'Originalas',

  // Hold music (parts.tsx).
  'Delete {name} and its tracks?': 'Ištrinti „{name}“ kartu su kūriniais?',
  'What callers hear while they wait in a queue. Upload your own tracks, then choose the music in the queue’s settings.':
    'Ką skambinantieji girdi laukdami eilėje. Įkelkite savo kūrinius, tada pasirinkite muziką eilės nustatymuose.',
  'New music': 'Nauja muzika',
  'The standard hold music plays': 'Grojama standartinė laukimo muzika',
  'Add your own: make a set, upload one or more tracks, and choose it for a queue.':
    'Pridėkite savo: sukurkite rinkinį, įkelkite vieną ar kelis kūrinius ir pasirinkite jį eilei.',
  Music: 'Muzika',
  Tracks: 'Kūriniai',
  'Add tracks': 'Pridėti kūrinių',
  'New hold music': 'Nauja laukimo muzika',
  Rename: 'Pervadinti',
  '{name}: tracks': '{name}: kūriniai',
  'They play in this order, again from the start after the last.': 'Grojami šia tvarka, po paskutinio – vėl nuo pirmojo.',
  'Calm music': 'Rami muzika',
  '{name} is over 20 MB.': 'Failas {name} didesnis nei 20 MB.',
  'Remove {name}?': 'Pašalinti „{name}“?',
  'Phone lines carry narrow audio, so music sounds as on any call. Use music you may play to callers (licensed for it). Each track up to 20 MB.':
    'Telefono linija perduoda siaurą garso ruožą, todėl muzika skamba kaip per bet kurį pokalbį. Naudokite muziką, kurią jums leidžiama groti skambinantiesiems (su tam skirta licencija). Kiekvienas kūrinys – iki 20 MB.',
  'No tracks yet: callers hear the standard music.': 'Kūrinių dar nėra: skambinantieji girdi standartinę muziką.',

  // Opening hours (parts.tsx).
  Mon: 'Pr',
  Tue: 'An',
  Wed: 'Tr',
  Thu: 'Kt',
  Fri: 'Pn',
  Sat: 'Št',
  Sun: 'Sk',
  // Lithuania's public holidays, added to a schedule as they are named here.
  'New Year’s Day': 'Naujųjų metų diena',
  'Restoration of the State': 'Valstybės atkūrimo diena',
  'Restoration of Independence': 'Nepriklausomybės atkūrimo diena',
  Easter: 'Velykos',
  'Labour Day': 'Tarptautinė darbo diena',
  'Midsummer (Joninės)': 'Joninės',
  'Statehood Day': 'Valstybės diena',
  'Assumption Day': 'Žolinė',
  'All Saints’ Day': 'Visų šventųjų diena',
  'All Souls’ Day': 'Vėlinės',
  Christmas: 'Kūčios ir Kalėdos',
  'Closed every day': 'Nedirbama nė vieną dieną',
  'Delete {name}?': 'Ištrinti „{name}“?',
  'Weekly hours, public holidays and one-off closures. A flow’s Opening hours element checks them for each call, in the region’s time zone.':
    'Savaitės darbo valandos, valstybinės šventės ir vienkartinės nedarbo dienos. Scenarijaus elementas „Darbo laikas“ jas tikrina kiekvienam skambučiui pagal regiono laiko juostą.',
  'New schedule': 'Naujas grafikas',
  'No opening hours yet': 'Darbo laiko grafikų dar nėra',
  Schedule: 'Grafikas',
  Now: 'Dabar',
  '{n} exceptions': { one: '{n} išimtis', few: '{n} išimtys', other: '{n} išimčių' },
  'New opening hours': 'Naujas darbo laiko grafikas',
  'What it is': 'Kas tai',
  Lunch: 'Pietūs',
  Period: 'Laikotarpis',
  'Office hours': 'Biuro darbo laikas',
  'Read in {timeZone}': 'Laikas pagal {timeZone}',
  'Every week': 'Kas savaitę',
  'Monday’s hours to Tue–Fri': 'Kopijuoti pirmadienį į An–Pn',
  'Outside these periods it is closed. A named period (Lunch) is its own way out in flows. A period that ends before it starts runs past midnight.':
    'Už šių laikotarpių ribų nedirbama. Pavadintas laikotarpis (pietūs) scenarijuose turi savo išėjimą. Laikotarpis, kuris baigiasi anksčiau nei prasideda, tęsiasi per vidurnaktį.',
  'Holidays and other days': 'Šventės ir kitos dienos',
  'Lithuanian holidays {year}': 'Lietuvos šventės {year}',
  Day: 'Diena',
  'None. Add public holidays and closures; with no periods the day is closed.':
    'Nėra. Pridėkite valstybines šventes ir nedarbo dienas; diena be laikotarpių yra nedarbo diena.',
  'e.g. Christmas': 'pvz., Kalėdos',
  'Closed all day': 'Nedirbama visą dieną',
  'Check the times: use HH:MM, and a name for each period.': 'Patikrinkite laiką: rašykite HH:MM ir kiekvienam laikotarpiui nurodykite pavadinimą.',

  // Caller lists (parts.tsx).
  'Delete the list {name}?': 'Ištrinti sąrašą „{name}“?',
  'Numbers a flow can recognise, such as VIP customers or blocked callers.': 'Numeriai, kuriuos scenarijus gali atpažinti, pavyzdžiui, VIP klientų ar užblokuotų skambinančiųjų.',
  'New list': 'Naujas sąrašas',
  'No caller lists yet': 'Skambintojų sąrašų dar nėra',
  List: 'Sąrašas',
  'New caller list': 'Naujas skambintojų sąrašas',
  'VIP customers': 'VIP klientai',
  'One per line': 'Po vieną eilutėje',
  'Line {n}: {error}': '{n} eilutė: {error}',
  // Table columns (Call flows, Opening hours).
  Changed: 'Pakeista',
  Hours: 'Darbo laikas',
};
